import { BooleanInput } from '@angular/cdk/coercion';
import { NgClass, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

import { TranslocoModule } from '@ngneat/transloco';

import { User } from 'app/core/user/user';
import { UserService } from 'app/core/user/user.service';
import { UserEventService } from 'app/core/user/user-event.service';


@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'user',
    standalone: true,
    imports: [
        MatButtonModule,
        MatMenuModule,
        NgIf,
        MatIconModule,
        NgClass,
        MatDividerModule,
        TranslocoModule
    ],
})
export class UserComponent implements OnInit, OnDestroy {

    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_showAvatar: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */

    @Input() showAvatar: boolean = false;
    user: User;

    /**Propiedad foto */
    public photo: any;




    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private _userService: UserService,
        private _userEventService: UserEventService
    ) {

        this._userEventService
            .eventPhoto
            .subscribe((user: User) => {
                if (user.Photo !== undefined && user.Photo !== "" && user.Photo !== null) {
                    this.photo = 'data:image/' + user.Format + ';base64,' + user.Photo;
                    this._changeDetectorRef.markForCheck();
                } else
                    this.photo = null;
            });

    }


    ngOnInit(): void {



        // Subscribe to user changes
        this._userService
            .user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user: User) => {
                this.user = user;
                if (this.user.Photo){
                    this.showAvatar = true;
                }
                if (user.Photo !== undefined && user.Photo !== "" && user.Photo !== null) {
                    this.photo = 'data:image/' + user.Format + ';base64,' + user.Photo;
                    this._changeDetectorRef.markForCheck();
                } else
                    this.photo = null;
            });
    }


    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    onAccount(): void {
        this._router.navigate(['/account']);
    }

    signOut(): void {
        this._router.navigate(['/sign-out']);
    }
}
